<template>
  <div class="lawyer-detail">
    <nav-header :activeIndex="2" />
    <main class="lawyer-detail-content">
      <div class="lawyer-detail-content-inner">
        <div class="lawyer-detail-content-inner-title">
          <router-link :to="{name: 'home'}">首页</router-link>
          > <router-link :to="{name: 'home-lawyer'}">圣诉律师</router-link> >
          <span>{{lawyerDetail.lawyerName}}</span>
        </div>
        <div class="lawyer-detail-content-inner-lawyer">
          <div class="lawyer-detail-content-inner-lawyer-avatar">
            <img style="height: 2.2rem;" :src="lawyerDetail.avatar" alt="">
          </div>
          <div class="lawyer-detail-content-inner-lawyer-message">
            <div class="lawyer-detail-content-inner-lawyer-message-top">
              <div class="lawyer-detail-content-inner-lawyer-message-top-left">
                <div class="title">{{lawyerDetail.lawyerName}}</div>
                <p>{{lawyerPositionFilter(lawyerDetail.lawyerPosition)}}</p>
                <p>从业时间 {{lawyerDetail.workYears > 50 ? 50 : lawyerDetail.workYears || '-'}} 年</p>
                <p>{{lawyerDetail.lawfirm}}</p>
                <div class="consult-btn" @click="getMeiQia">立即咨询</div>
                <p class="help">在圣诉平台帮助了{{lawyerDetail.helper}}位用户</p>
              </div>
              <div class="lawyer-detail-content-inner-lawyer-message-top-right" v-if="lawyerDetail.description">
                <img src="./assets/icon-quote-left.svg" alt="">
                <p class="content">
                  {{lawyerDetail.description}}
                </p>
                <img class="right" src="./assets/icon-quote-up.svg" alt="">
              </div>
            </div>
            <div class="lawyer-detail-content-inner-lawyer-message-bottom">
              <div class="lawyer-detail-content-inner-lawyer-message-bottom-license">
                <p class="title">执业证号</p>
                <p class="content">{{lawyerDetail.practiceAccount}}</p>
                <p class="title location">所在地区</p>
                <p class="content">{{lawyerDetail.province + '-' + lawyerDetail.city}}</p>
              </div>
              <div class="lawyer-detail-content-inner-lawyer-message-bottom-field" v-if="lawyerDetail.expertField">
                <p class="title">专长领域</p>
                <p class="content" v-for="(item, ind) in expertFieldFilter(lawyerDetail.expertField)" :key="ind">
                  <span>{{item}}</span>
                </p>
              </div>
              <div class="lawyer-detail-content-inner-lawyer-message-bottom-honor" v-if="lawyerDetail && lawyerDetail.lawyerHonor">
                <p class="title">所获荣誉</p>
                <p class="content">
                  <span>{{lawyerDetail.lawyerHonor}}</span>
                </p>
              </div>
              <div class="lawyer-detail-content-inner-lawyer-message-bottom-case" v-if="lawyerDetail && lawyerDetail.lawyerCaseContent">
                <p class="title">经典案例</p>
                <div class="content">
                  <div class="content-inner">
                    <p class="title">{{lawyerDetail.lawyerCaseContent}}</p>
                    <div class="con">
                      {{lawyerDetail.lawyerCaseContent}}
                      <router-link tag="p" :to="{name: 'article-detail', query: {lawyerId: $route.query.lawyerId}}"  class="detail">...<b>详情</b></router-link>
                    </div>
                  </div>
                  <div class="consult-btn" @click="getMeiQia">立即咨询</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
  import api from './api'
  import { Message } from 'element-ui/lib'
  import { clickShowMeiQia } from '@/utils/meiqia'
  import NavHeader from '@/common-components/nav-header'
  export default {
    name: 'home-lawyer',
    components: { NavHeader },
    data () {
      return {
        lawyerDetail: {}
      }
    },
    mounted () {
      this.getLawyerDetail()
    },
    methods: {
      // 职位转化
      lawyerPositionFilter (data) {
        let obj = {1: '主任', 2: '副主任', 3: '执行主任', 4: '高级合伙人', 5: '合伙人', 6: '律师', 7: '其他'}
        return obj[data]
      },
      // 专业领域转化
      expertFieldFilter (data) {
        let arr = []
        let fileArr = { 1: '综合', 2: '诉讼业务(诉讼与仲裁)', 3: '非诉业务', 4: '政府法律顾问', 5: '企业法律顾问', 6: '刑事辩护', 7: '行政业务', 8: '民商事', 9: '婚姻家庭', 10: '交通事故', 11: '合同纠纷', 12: '劳动', 13: '国际业务', 14: '知识产权', 15: '公司业务', 16: '金融、证券、保险', 17: '资本市场、IPO、新三板', 18: '海商海事', 19: '环境、资源与能源', 20: '破产与重组', 21: '建设工程', 22: '房地产', 23: '财税', 24: '债权债务', 25: '房产纠纷', 26: '其他' }
        if (data === '' || data === null || data === undefined) return
        JSON.parse(data).forEach(item => {
          arr.push(fileArr[item])
        })
        return arr
      },
      async getLawyerDetail () {
        let res = await api.getLawyerDetail(this.$route.query.lawyerId)
        if (res.data.isSuccess) {
          this.lawyerDetail = res.data.data
        } else {
          Message.error(res.data.resultMsg)
        }
      },
      getMeiQia () {
        clickShowMeiQia()
      }
    }
  }
</script>

<style lang='stylus' scoped>
  @import '../../styles/constant.styl'
  .lawyer-detail {
    &-content {
      width: 100%
      background #f7f7f7
      margin-top .72rem
      &-inner {
        width: 9.6rem
        margin 0 auto
        padding .24rem 0 .64rem 0
        &-title {
          font-size: .16rem;
          color: #1d1b1b;
          margin-bottom .48rem
          span {
            color: #a9a9a9;
          }
        }
        &-lawyer {
          position relative
          display flex
          justify-content flex-end
          &-avatar {
            position absolute
            left 0
            top .58rem
            width: 2.2rem
            height: 2.2rem
            text-align: right
          }
          &-message {
            width: 8.6rem
            &-top {
              display flex
              background #fff
              height 3.35rem
              padding .58rem .8rem 0 1.88rem
              justify-content space-between
              margin-bottom .24rem
              &-left {
                .title {
                  font-size: .36rem;
                  font-weight: 500;
                  line-height: .45rem;
                }
                p {
                  font-size: .16rem
                  line-height: .32rem;
                  color: #000
                  overflow: hidden;
                  text-overflow:ellipsis;
                  white-space: nowrap;
                }
                .help {
                  text-align center
                  font-size: .12rem;
                  line-height: .24rem;
                  color: #ed6c00;
                }
              }
              &-right {
                width: 3rem
                height: 1.32rem
                img {
                  width: .32rem
                  height: .32rem
                }
                .right {
                  float right
                }
                .content {
                  margin .15rem 0
                  height: 1.32rem
                  font-size: .16rem
                  color: #a9a9a9;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 6;
                  overflow: hidden;
                }
              }
            }
            &-bottom {
              background #fff
              padding 0 0 .48rem .24rem
              .title {
                margin-right .32rem
                font-size: .16rem;
                font-weight: 500;
                color: #1d1b1b;
                flex-shrink 0
              }
              .location {
                margin-left .59rem
              }
              &-license, &-field {
                height .72rem
                line-height .72rem
                display: flex
              }
              &-field {
                span {
                  padding .07rem .16rem
                  border-radius: .3rem;
                  background-color: #ffe9d2;
                  font-size: .14rem
                  color: #ed6c00
                  margin-right .16rem
                }
              }
              &-honor {
                display flex
                padding .28rem 0 .24rem 0
                .content {
                  width: 7rem
                  span {
                    width: 7rem
                    display block
                    color: #3e3a3a;
                    margin-bottom .22rem
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 5;
                    overflow: hidden;
                  }
                }
              }
              &-case {
                display flex
                .content {
                  .title {
                    width: 6rem
                    color: #3e3a3a;
                    overflow: hidden;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                  }
                  .con {
                    width: 7rem
                    color: #a9a9a9;
                    line-height .24rem
                    margin .16rem 0 .32rem 0
                    position relative
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 3;
                    overflow: hidden;
                    p {
                      width: 6rem
                      position absolute
                      bottom 0
                      left 1rem
                      background #fff
                      cursor pointer
                      b {
                        color: #1d1b1b;
                      }
                    }
                  }
                }
              }
            }
            .consult-btn {
              width: 1.9rem;
              height: .48rem;
              border: solid 1px #1d1b1b;
              color #1d1b1b
              line-height .48rem
              font-weight: 500
              margin .1rem 0 .04rem 0
              text-align center
              cursor pointer
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/lawyer-detail/lawyer-detail.vue